/**
 * Color swatches (色玉)
 * - Product cards: hover/tap preview + navigate to variant URL
 * - PDP: hover color swatch previews featured product image
 */
(function () {
  const SWATCH_SELECTOR = '[data-color-swatch]';
  const ROOT_SELECTOR = '[data-color-swatches]';
  const CARD_SELECTOR = '[data-product-card]';
  const IMAGE_SELECTOR = '[data-card-primary-image]';
  const PDP_SWATCH_SELECTOR = '[data-pdp-color-swatch]';
  const PREVIEW_CLASS = 'is-color-swatch-preview';
  const TOUCH_MQ = '(hover: none) and (pointer: coarse)';

  let bound = false;
  let activeTouchSwatch = null;

  function isTouchLike() {
    return window.matchMedia(TOUCH_MQ).matches;
  }

  function getCardContext(swatch) {
    const root = swatch.closest(ROOT_SELECTOR);
    if (!root) return null;

    const card = root.closest(CARD_SELECTOR) || root.closest('.card-wrapper');
    if (!card) return null;

    const image = card.querySelector(IMAGE_SELECTOR);
    if (!image) return null;

    return { root, card, image };
  }

  function setActiveSwatch(root, swatch) {
    root.querySelectorAll(SWATCH_SELECTOR).forEach((item) => {
      item.classList.toggle('is-active', item === swatch);
    });
  }

  function enablePreviewMode(card) {
    card.classList.add(PREVIEW_CLASS);
  }

  function previewCard(swatch) {
    const ctx = getCardContext(swatch);
    if (!ctx) return;

    enablePreviewMode(ctx.card);
    setActiveSwatch(ctx.root, swatch);
    activeTouchSwatch = swatch;

    if (swatch.dataset.hasVariantImage !== 'true') {
      return;
    }

    if (swatch.dataset.imageSrc) {
      ctx.image.src = swatch.dataset.imageSrc;
    }

    if (swatch.dataset.imageSrcset) {
      ctx.image.srcset = swatch.dataset.imageSrcset;
    }

    if (swatch.dataset.imageAlt) {
      ctx.image.alt = swatch.dataset.imageAlt;
    }

    ctx.card.querySelectorAll('.media--hover-effect img:not([data-card-primary-image])').forEach((img) => {
      img.setAttribute('hidden', '');
      img.style.opacity = '0';
    });

    ctx.image.style.opacity = '1';
    ctx.image.removeAttribute('hidden');
  }

  function openVariant(swatch) {
    const url = swatch.dataset.variantUrl;
    if (url) {
      window.location.href = url;
    }
  }

  function resolvePdpSwatchInput(target) {
    if (!target || !target.closest) return null;

    const direct = target.closest(PDP_SWATCH_SELECTOR);
    if (direct) return direct;

    const label = target.closest('label.swatch-input__label');
    if (!label) return null;

    const inputId = label.getAttribute('for');
    if (!inputId) return null;

    const input = document.getElementById(inputId);
    if (!input || !input.hasAttribute('data-pdp-color-swatch')) return null;

    return input;
  }

  function getPdpScope(input) {
    return (
      input.closest('product-info') ||
      input.closest('[id^="MainProduct-"]') ||
      input.closest('.product') ||
      document.querySelector('product-info') ||
      document
    );
  }

  function getPdpFeaturedImage(scope) {
    return (
      scope.querySelector('.product__media-list .product__media-item.is-active img') ||
      scope.querySelector('.product__media-list .product__media-item img') ||
      scope.querySelector('media-gallery img')
    );
  }

  function applyImagePreview(img, input) {
    if (!img) return false;

    let changed = false;

    if (input.dataset.imageSrc) {
      img.src = input.dataset.imageSrc;
      changed = true;
    }

    if (input.dataset.imageSrcset) {
      img.srcset = input.dataset.imageSrcset;
      changed = true;
    }

    // Avoid lazy-loader keeping an old frame
    if (changed) {
      img.removeAttribute('loading');
      img.style.opacity = '1';
      img.removeAttribute('hidden');
    }

    return changed;
  }

  function previewPdp(input) {
    const scope = getPdpScope(input);
    const mediaId = input.dataset.mediaId;
    const list = scope.querySelector('.product__media-list');
    const mediaItem = mediaId ? scope.querySelector(`.product__media-list [data-media-id="${mediaId}"]`) : null;

    // Stacked layout shows many images; move target media to the first slot (no page jump).
    if (list && mediaItem) {
      list.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('is-active'));
      mediaItem.classList.add('is-active');
      if (list.firstElementChild !== mediaItem) {
        list.prepend(mediaItem);
      }
    }

    // Swap featured image src as well (covers hide_variants / missing media-item cases).
    applyImagePreview(getPdpFeaturedImage(scope), input);
  }

  function onPointerOver(event) {
    // Ignore coarse-touch pointers; mouse/pen should still preview even if hover:none is misreported
    if (event.pointerType === 'touch') return;

    const pdpInput = resolvePdpSwatchInput(event.target);
    if (pdpInput) {
      previewPdp(pdpInput);
      return;
    }

    if (isTouchLike()) return;

    const swatch = event.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;

    previewCard(swatch);
  }

  // mouseover is a reliable desktop fallback for PDP labels/spans
  function onMouseOver(event) {
    if (isTouchLike()) return;

    const pdpInput = resolvePdpSwatchInput(event.target);
    if (!pdpInput) return;

    previewPdp(pdpInput);
  }

  function onClick(event) {
    const swatch = event.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();

    if (isTouchLike() && activeTouchSwatch !== swatch) {
      previewCard(swatch);
      return;
    }

    openVariant(swatch);
  }

  function onKeyDown(event) {
    const swatch = event.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();
      openVariant(swatch);
    }
  }

  function bindDelegatedEvents() {
    if (bound) return;
    bound = true;

    document.addEventListener('pointerover', onPointerOver);
    document.addEventListener('mouseover', onMouseOver);
    document.addEventListener('click', onClick, true);
    document.addEventListener('keydown', onKeyDown);
  }

  function init() {
    bindDelegatedEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('facet:updated', init);
})();
